import { APIPath } from 'utility/constant'
import { BaseService } from './base'

class ActionPlanCategoryServiceClass {
    /** Admin list — includes inactive (IsActive=0). */
    list() {
        return BaseService.get(APIPath.actionPlanCategory)
    }

    create(data) {
        return BaseService.post(APIPath.actionPlanCategory, data)
    }

    update(categoryId, data) {
        return BaseService.put(
            APIPath.actionPlanCategoryById(categoryId),
            data,
        )
    }

    /** Soft-delete (IsActive=0). Already inactive → 404. */
    remove(categoryId) {
        return BaseService.remove(APIPath.actionPlanCategoryById(categoryId))
    }
}

export const ActionPlanCategoryService = new ActionPlanCategoryServiceClass()
